import { FeatureToggleClientService } from 'feature-toggle-client';
export const areFailingWebhooksBeingBlocked = 'are-failing-webhooks-being-blocked';
export const isShowingTicketsTypesWebhooks = 'is-showing-tickets-on-types-webhooks';
export const isShowingOAuthOnWebhooks = 'is-showing-oauth-on-webhooks';
export const isShowingDispatchTypesSettings = 'is-showing-dispatchTypes-settings';
export const isShowingCustomHeadersOnWebhooks = 'is-showing-custom-headers-on-webhooks';
export const isShowingMonitoringsWebhooks = 'is-showing-monitorings-webhooks';
export class WebhookFeatures {
    static async areFailingWebhooksBeingBlocked() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(areFailingWebhooksBeingBlocked);
    }
    static async isShowingTicketsTypesWebhooks() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isShowingTicketsTypesWebhooks);
    }
    static async isShowingOAuthOnWebhooks() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isShowingOAuthOnWebhooks);
    }
    static async isShowingDispatchTypesSettings() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isShowingDispatchTypesSettings);
    }
    static async isShowingCustomHeadersOnWebhooks() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isShowingCustomHeadersOnWebhooks);
    }
    static async isShowingMonitoringsWebhooks() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isShowingMonitoringsWebhooks);
    }
}
